/**
 * Device-local manual lock flag (NOT derived from hasPin).
 * Web + Electron share renderer localStorage.
 */
const STORAGE_PREFIX = 'notesplus_lock_active_';

const storageKey = (userId) => `${STORAGE_PREFIX}${userId}`;

export const getLockActive = (userId) => {
  if (!userId || typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(storageKey(userId)) === '1';
  } catch (_) {
    return false;
  }
};

export const setLockActive = (userId, active) => {
  if (!userId || typeof window === 'undefined') return;
  try {
    const key = storageKey(userId);
    if (active) {
      window.localStorage.setItem(key, '1');
    } else {
      window.localStorage.removeItem(key);
    }
    window.dispatchEvent(
      new CustomEvent('notesplus-lock-changed', {
        detail: { userId: String(userId), lockActive: !!active },
      })
    );
  } catch (_) {
    // ignore quota / private mode
  }
};

export const clearLockActive = (userId) => setLockActive(userId, false);

/** Best-effort: clear all lock flags (logout without userId known). */
export const clearAllLockActive = () => {
  if (typeof window === 'undefined') return;
  try {
    const keys = [];
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const k = window.localStorage.key(i);
      if (k && k.startsWith(STORAGE_PREFIX)) keys.push(k);
    }
    keys.forEach((k) => window.localStorage.removeItem(k));
    window.dispatchEvent(
      new CustomEvent('notesplus-lock-changed', {
        detail: { userId: null, lockActive: false },
      })
    );
  } catch (_) {
    // ignore
  }
};
